export default __webpack_public_path__ + "static/media/gcp.493302ee.svg";